export const GALLERY_SELECTOR = '.js-above-the-fold-gallery';
export const MEDIA_SELECTOR = 'js-above-the-fold-gallery-media';
export const THUMBNAIL_SELECTOR = 'js-above-the-fold-gallery-thumbnail';
export const THUMBNAIL_IMAGE_SELECTOR = 'js-above-the-fold-gallery-thumbnail-image';
export const LEFT_ARROW_SELECTOR = 'js-gallery-arrow-left';
export const RIGHT_ARROW_SELECTOR = 'js-gallery-arrow-right';

export const FULL_PAGE_GALLERY = '.js-above-the-fold-full-page-gallery';
export const FULL_PAGE_GALLERY_CLOSE = '.js-above-the-fold-full-page-gallery-close';
export const FULL_PAGE_GALLERY_WRAPPER = '.js-above-the-fold-full-page-gallery-wrapper';

export const GALLERY_SELECTOR_WRAPPER = 'js-above-the-fold-gallery-selector-wrapper';
